<template>
  <v-container grid-list-xl>
    <v-layout justify-center>
		<v-progress-circular class="white--text" indeterminate v-if="loading"></v-progress-circular>
		<div class="white--text">Loading {{getFilename(s3key)}}</div>
    </v-layout>
  </v-container>
</template>

<script>
import config from '../config'
import axios from 'axios'

export default {
	name: 'doc'
	,data () {
		return {
			s3key: null
			,bucket: ""
			,loading : false
		}
	}
	,methods:
	{
		getFilename(fullpath)
		{
			if (fullpath)
			{
				let pathparts = fullpath.split('/')
				let numpathparts = pathparts.length
				if (numpathparts > 0)
				{
					return pathparts[numpathparts - 1]
				}
			}
			else
				return fullpath
		}
	}
	,watch:
	{
		s3key: function(key)
		{
			if (key)
			{
				axios.get(config.QSS + "s3/" + this.bucket + "/downloadurlportal", {headers: { Authorization: this.$store.state.auth.idToken }, params: {key: key}})
				.then((response) =>
				{
					let data = JSON.parse(response.data)
					this.loading = false
					window.location.replace(data.url)
				})
			}
		}
	}
	,mounted()
	{
		console.log("docview")
		if (this.$route.params.key && this.$route.params.key.length > 0)
		{
			this.loading = true

			// we expect a : delimiter between the bucket and key
			let foundat = this.$route.params.key.indexOf(":")
			if (foundat >= 0)
			{
				var keyparts = this.$route.params.key.split(":")
				console.log("keyparts: " + keyparts)

				this.bucket = keyparts[0]
				this.s3key = keyparts[1]
			}
			else
			{
				console.log("Error splitting key param")
			}
		}
	}
}
</script>
